import {
    Alert,
    Box,
    Button,
    Card,
    CardMedia,
    Chip,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import { useContext } from "react";
import { CourseDto } from "../../../api/psc";
import { CardInformation } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogContext";
import { toJalaliDate } from "../../../utils/date";
import RegisterInCourseDialog from "../dialogs/RegisterInCourseDialog";

export default function CourseItem(props: { course: CourseDto }) {
    const { openDialog } = useContext(DialogContext);

    const openRegistrationDialog = () => {
        openDialog(<RegisterInCourseDialog courseId={props.course.id} />);
    };

    return (
        <Card>
            <CardMedia sx={{ position: "relative" }}>
                <img
                    style={{ width: "100%", height: "auto" }}
                    src={props.course.imageSrc}
                />

                {!props.course.isExpired && !props.course.isCapacityFull && (
                    <Box sx={{ position: "absolute", top: 16, right: 16 }}>
                        <Chip label="فعال - قابل ثبت نام" color="success" />
                    </Box>
                )}
            </CardMedia>

            <Stack
                spacing={2}
                direction="column"
                alignItems="start"
                sx={{ p: 2 }}
            >
                <Typography color="primary">{props.course.title}</Typography>

                <Typography sx={{ whiteSpace: "pre-line" }}>
                    {props.course.description}
                </Typography>

                {props.course.isCapacityFull && (
                    <Alert severity="warning" sx={{ width: "100%" }}>
                        ظرفیت تکمیل شده است
                    </Alert>
                )}

                {props.course.isExpired && (
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        disabled
                    >
                        تاریخ ثبت نام پایان یافته است
                    </Button>
                )}

                {!props.course.isExpired && (
                    <>
                        <Divider flexItem />

                        <CardInformation
                            title="مهلت ثبت نام"
                            value={toJalaliDate(
                                props.course.registrationExpiration
                            )}
                        />
                        <CardInformation
                            title="تاریخ شروع"
                            value={props.course.humanReadableDate}
                        />

                        <Button
                            variant="contained"
                            fullWidth
                            color="primary"
                            onClick={openRegistrationDialog}
                        >
                            جزییات دوره و ثبت نام
                        </Button>
                    </>
                )}
            </Stack>
        </Card>
    );
}
